import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { incidentRegistersApi, templateApi } from '../services/api';
import { RegisterManagementPage } from './RegisterManagementPage';
import type { Template } from '../types/models';

export const IncidentRegistersPage: React.FC = () => {
  // Fetch active templates for incident category
  const { data: templates = [] } = useQuery({
    queryKey: ['templates', 'incident'],
    queryFn: () => templateApi.list('incident'),
  });

  // Convert templates to options for dropdown
  const templateOptions = templates
    .filter((t: Template) => t.isActive)
    .map((t: Template) => ({
      value: t.templateName,
      label: t.displayName,
    }));

  // Default to 'standard' or first available template
  const defaultTemplate = templateOptions.find((t: any) => t.value === 'standard')?.value || templateOptions[0]?.value || 'standard';

  return (
    <RegisterManagementPage
      title="Incident Registers"
      iconClass="ri-folder-line"
      queryKey="incidentRegisters"
      api={incidentRegistersApi}
      includeDepartments
      templates={templateOptions}
      defaultTemplate={defaultTemplate}
      listPath="/incidents"
      configPath="/incident-config"
      applyTemplateKind="incident"
      countField="incidentCount"
      countLabel="Incidents"
      allowForceDelete
    />
  );
};
